import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiTableCell from '@mui/material/TableCell';
import styled from 'src/ui/library/styled';

const styles = (theme, props) => ({
  root: {
    height: '50px',
    border: 'none',
    color: `${theme.colors.eyConfidentGrey}`,
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: '#FFF',
    position: 'sticky',
    top: '0px',
    whitespace: 'nowrap',
    zIndex: 99,
    '&:before': {
      content: "''",
      position: 'absolute',
      left: 0,
      width: '100%',
      height: '100%',
      borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
      display: 'block',
      top: '1px',
      zIndex: -1,
    },
  },
  firstColumn: {
    '&:before': {},
  },
  lastColumn: {
    '&:before': {},
  },
  wrapper: {
    display: 'flex',
  },
  displayText: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  sort: {
    display: 'inline-block',
    verticalAlign: 'top',
    cursor: 'pointer',
    paddingLeft: '10px',
    paddingTop: '2px',
    height: '10px',
  },
  noSort: {
    visibility: 'hidden',
  },
  stickyColumn: {
    left: '0px',
    zIndex: 200,
    //borderBottom: 'solid 1px #eaeaf2',
    //boxShadow: '2px 0 2px 0 rgba(234,234,242,0.01)',
  },
  arrowIcon: {
    width: '8px',
    height: '5px',
    display: 'block',
    paddingBottom: '1px',
    '& svg': {
      width: '8px',
      height: '5px',
      verticalAlign: 'top',
      '& path': {
        fillOpacity: 0.35,
      },
    },
    '&:focus': {
      outline: 'none',
    },
  },
  arrowBottom: {
    marginTop: '5px',
  },
  ...(props.styleOverrides ? { ...props.styleOverrides } : {}),
});

class TableHeadCell extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /** Column index value */
    colIndex: PropTypes.number,
    /** Developer styles overrides */
    styleOverrides: PropTypes.object.isRequired,
  };

  handleCheckboxSelection = event => {
    const isChecked = event.currentTarget.checked === true ? true : false;
    // this.setState({selectAll: isChecked});
    this.props.enableHeaderSelection(isChecked, this.props.name);
  };

  handleSort = (colData, colIndex) => {
    if (colData.sortable) {
      this.props.onChangeSort(colData, colIndex);
    }
  };

  render() {
    const { classes, colData, colIndex, totalColumns, hardDisplay, idName, enableHeaderSelection, markAllSelectionFlag } = this.props;

    if (!colData.visible || (!colData.displayUI && !hardDisplay)) return null;

    const colClass = classNames({
      [classes.root]: true,
      [classes.firstColumn]: colIndex === 0,
      [classes.lastColumn]: colIndex === totalColumns - 1,
      [classes.stickyColumn]: colData.sticky || false,
    });

    const sortClass = classNames({
      [classes.sort]: true,
      [classes.noSort]: colData.sortable === false,
    });

    return (
      <MuiTableCell className={colClass} onClick={this.handleSort.bind(null, colData, colIndex)} scope={'col'}>
        <div className={classes.wrapper} id={idName}>
          <div className={classes.displayText}>
            {enableHeaderSelection && idName === 'markSelection' ? (
              <input
                checked={markAllSelectionFlag ? true : false}
                type="checkbox"
                id="markSelectionAll"
                name={'markSelectionAll'}
                onChange={event => this.handleCheckboxSelection(event)}
              />
            ) : (
              colData.displayText
            )}
          </div>
          <div className={sortClass}>
            <span className={classes.arrowIcon}>
              <svg>
                <path
                  d="m7.54878,4.12621q0,0.20139 -0.13005,0.34856t-0.30802,0.14717l-6.13296,0q-0.17796,0 -0.30802,-0.14717t-0.13005,-0.34856t0.13005,-0.34856l3.06648,-3.47017q0.13005,-0.14717 0.30802,-0.14717t0.30802,0.14717l3.06648,3.47017q0.13005,0.14717 0.13005,0.34856l0,0l0,0z"
                  fill="black"
                />
              </svg>
            </span>
            <span className={classNames(classes.arrowIcon, classes.arrowBottom)}>
              <svg>
                <path
                  d="m 0.53968,0.65604 q 0,-0.20139 0.13005,-0.34856 0.13005,-0.14717 0.30802,-0.14717 l 6.13296,0 q 0.17796,0 0.30802,0.14717 0.13006,0.14717 0.13005,0.34856 -10e-6,0.20139 -0.13005,0.34856 L 4.35225,4.47477 Q 4.2222,4.62194 4.04423,4.62194 q -0.17797,0 -0.30802,-0.14717 L 0.66973,1.0046 Q 0.53968,0.85743 0.53968,0.65604 v 0 z"
                  fill="black"
                />
              </svg>
            </span>
          </div>
        </div>
      </MuiTableCell>
    );
  }
}

export default styled(TableHeadCell)(styles);
